import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MarketplaceItemStatus, ScreenSizeService } from '@fgb/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

interface FilterOption {
  label: string,
  value: string | number
}
@Component({
  selector: 'fgbcl-filter-status-modal',
  templateUrl: './filter-status-modal.component.html',
  styleUrls: ['./filter-status-modal.component.scss'],
})
export class FilterStatusModalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() showStatusFilter: boolean = false;
  @Input() filterTypesList: FilterOption[];
  @Output() filterTypesListEmitter: EventEmitter<FilterOption[]> = new EventEmitter<FilterOption[]>();
  @Input() selectedValues: number[];
  @Output() selectedValuesEmitter: EventEmitter<number[]> = new EventEmitter<number[]>();
  showFilterOption: boolean = false;
  screenSize: number = 0;

  defaultSelectedValues: any[] = [];
  defaultFilterTypesList: FilterOption[] = [];

  filterTypesOptions: FilterOption[] = [
    { label: 'reward.filter.status.all', value: MarketplaceItemStatus.All },
    { label: 'reward.filter.status.available', value: MarketplaceItemStatus.Available },
    { label: 'reward.filter.status.sold.out', value: MarketplaceItemStatus.SoldOut },
    { label: 'reward.filter.status.not.enough.point', value: MarketplaceItemStatus.NotEnoughPoints },
    { label: 'reward.filter.status.coming.soon', value: MarketplaceItemStatus.ComingSoon },
  ];
  MarketplaceItemStatus = MarketplaceItemStatus;
  screenSizeSubcription: Subscription
  @ViewChild('myOffcanvas', { static: false }) myOffcanvas: NgbOffcanvas;

  get labelString(): string {
    return this.filterTypesList.length === 1
      ? this.filterTypesList.map((type: FilterOption) => type.label).join(', ')
      : `(${this.filterTypesList.length})`;
  }

  constructor(private screenSizeServices: ScreenSizeService, private elementRef: ElementRef) { }

  ngOnInit() {
    this.screenSizeSubcription = this.screenSizeServices.selectScreenWidth().subscribe((size: number) => (this.screenSize = size));
    this.defaultSelectedValues = [...this.selectedValues];
    this.defaultFilterTypesList = [...this.filterTypesList];
  }

  ngOnChanges(changes: SimpleChanges) {

    this.defaultSelectedValues = [...this.selectedValues];
    this.defaultFilterTypesList = [...this.filterTypesList];

  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: any) {
    const filterResult = document.querySelector('.filter-result');
    const optionList = document.querySelector('.filter-select-option');
    if (filterResult && optionList && !filterResult.contains(event.target) && !optionList.contains(event.target)) {
      this.toggleShowFilterOption();
    }
  }

  toggleShowFilterOption() {
    if (this.screenSize >= 600) {
      this.showFilterOption = !this.showFilterOption;
    } else {
      this.addStyleBackdrop();
    }
  }

  handleChangeSelectType(value: number) {
    if (value !== MarketplaceItemStatus.All) {
      const specificSelectedItem = this.defaultSelectedValues.find((val) => val === value);
      const specificItem = this.filterTypesOptions.find(
        (item: FilterOption) => item.value === value
      );

      // item not in the list
      if (specificSelectedItem == undefined && specificItem) {
        this.defaultSelectedValues.push(specificItem.value);
        this.defaultSelectedValues = this.defaultSelectedValues.filter((val) => val !== MarketplaceItemStatus.All);

        if (specificItem) {
          this.defaultFilterTypesList.push(specificItem);
          this.defaultFilterTypesList = this.defaultFilterTypesList.filter(
            (item: FilterOption) => item.value !== MarketplaceItemStatus.All
          );
        }
      } else {
        this.defaultSelectedValues = this.defaultSelectedValues.filter((val) => val !== specificSelectedItem);
        if (specificItem) {
          this.defaultFilterTypesList = this.defaultFilterTypesList.filter(
            (item: FilterOption) => item.value !== specificItem.value
          );
        }
      }
    }

    // uncheck all others options or check All option
    if (this.defaultFilterTypesList.length === 0 || value === MarketplaceItemStatus.All) {
      this.defaultSelectedValues = [MarketplaceItemStatus.All];
      this.defaultFilterTypesList = [{ label: 'reward.filter_modal.all', value: MarketplaceItemStatus.All }];
    }

    this.defaultSelectedValues = [...new Set(this.defaultSelectedValues)];
    this.defaultFilterTypesList = [...new Set(this.defaultFilterTypesList)];


    if (this.screenSize >= 600) {
      this.filterTypesListEmitter.emit(this.defaultFilterTypesList);
      this.selectedValuesEmitter.emit(this.defaultSelectedValues);
    }
  }

  handleCloseOffCanvas() {
    this.defaultSelectedValues = [];
    this.defaultFilterTypesList = [];
  }

  handleApplyFilters() {
    this.filterTypesListEmitter.emit(this.defaultFilterTypesList);
    this.selectedValuesEmitter.emit(this.defaultSelectedValues);
    this.handleCloseOffCanvas();
  }

  addStyleBackdrop() {
    this.elementRef.nativeElement.querySelector('.modal-backdrop').style = 'z-index:999;opacity:0.15;';
  }

  ngOnDestroy(): void {
    this.screenSizeSubcription.unsubscribe();
  }
}
